import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'

import footerStyle from 'assets/jss/material-dashboard-pro-react/components/footerStyle'
import { GeneralData } from 'staticConfig.js'

function Footer({ ...props }) {
  const { classes, fluid, white } = props
  var container = cx({
    [classes.container]: !fluid,
    [classes.containerFluid]: fluid,
    [classes.whiteColor]: white
  })
  var anchor =
    classes.a +
    cx({
      [' ' + classes.whiteColor]: white
    })
  var block = cx({
    [classes.block]: true,
    [classes.whiteColor]: white
  })

  const {
    info: { version, productName, productURL }
  } = GeneralData
  return (
    <footer className={classes.footer}>
      <div className={container}>
        <div className={classes.left}>
          <List className={classes.list}>
            <ListItem className={classes.inlineBlock}>
              <a href="#home" className={block}>
                {'Home'}
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a href="https://www.gammana.com" className={block}>
                {'GAMMA'}
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a href="https://www.hygateliving.com/" className={block}>
                {'Hygate Living'}
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a href="_self" className={block}>
                {'Blog'}
              </a>
            </ListItem>
          </List>
        </div>
        <p className={classes.right}>
          &copy; {1900 + new Date().getYear()}{' '}
          <a href={productURL} className={anchor}>
            {`${productName} [${version}]`}
          </a>
          {', made with care for productivity'}
        </p>
      </div>
    </footer>
  )
}

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
  fluid: PropTypes.bool,
  white: PropTypes.bool,
  rtlActive: PropTypes.bool
}

export default withStyles(footerStyle)(Footer)
